import ClientNotificationInterface from '../../interfaces/client/Notification'

export default (
  notifications: ClientNotificationInterface[],
  fieldName: string,
  isInfant = false
) =>
  notifications.find(
    (notification: ClientNotificationInterface) =>
      notification.fieldName === fieldName &&
      Boolean(notification.isInfant) === isInfant
  )
